"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleToI18nDomainResult = void 0;
const data_type_1 = require("../../data/data-type");
const query_output_1 = require("./query-output");
/**
 * Data available as part of a CXTuple to I18nDomain query result.
 */
class CXTupleToI18nDomainResult extends query_output_1.QueryOutput {
}
exports.CXTupleToI18nDomainResult = CXTupleToI18nDomainResult;
/**
 * I18nDomain is stored in string format
 */
CXTupleToI18nDomainResult.I18N_DOMAIN = new CXTupleToI18nDomainResult('i18n_domain', data_type_1.DataType.STRING);
//# sourceMappingURL=cx-tuple-to-i18n-domain-result.js.map